import { useFetch } from '@/lib/react-query';
import { IHelpdeskTicketTypes } from '@/types/helpdesk';
import { apiRoutes } from '@/utils/routes';

export const useGetHelpdeskTicketTypes = (params?: Record<string, any>) =>
  useFetch<IHelpdeskTicketTypes[]>(apiRoutes.getHelpdeskTicketTypes, params);
